import { combineApiConfigs, createMetroApiConfig, createProtoV1ApiConfig, QueryConfigTypes } from '../../infra/apis-infra';
import * as MetaSiteSearchService from '@wix/ambassador-metasite-search-v2-search-entry/http';
import * as FeaturesManagerService from '@wix/ambassador-premium-features-manager-v1-feature/http';
import { PremiumDomainRegistrar } from '@wix/ambassador-premium-domain-registrar/http';
import * as PremiumStoreCurrencyService from '@wix/ambassador-premium-store-v1-currency/http';
import * as PremiumStoreDynamicOfferingService from '@wix/ambassador-premium-store-v1-dynamic-offering-service-entity/http';
import * as PremiumStoreSalesService from '@wix/ambassador-premium-store-v1-sales/http';
import { PremiumResellerMgmt } from '@wix/ambassador-premium-reseller-mgmt/http';
import { PremiumDataViewRetrieverServer } from '@wix/ambassador-premium-data-view-retriever-server/http';
import { WixMetaSiteManagerWebapp } from '@wix/ambassador-wix-meta-site-manager-webapp/http';
export const MetaSiteSearchApiConfig = createMetroApiConfig(MetaSiteSearchService);
export const DomainRegistrarApiConfig = createProtoV1ApiConfig(PremiumDomainRegistrar('/_api/domain-registrar').Registrar()());
export const PremiumFeaturesManagerApiConfig = createMetroApiConfig(FeaturesManagerService, {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.MODERATE_DATA
  }
});
export const PremiumResellerMgmtApiConfig = createProtoV1ApiConfig(PremiumResellerMgmt('/_api/premium-reseller-mgmt').ResellerInternal()(), {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.MODERATE_DATA
  }
});
export const PremiumCurrencyApiConfig = createMetroApiConfig(PremiumStoreCurrencyService, {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.FIXED_DATA
  }
});
export const PremiumStoreDynamicOfferingApiConfig = createMetroApiConfig(PremiumStoreDynamicOfferingService, {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.FIXED_DATA
  },
  methodsOptions: {
    createOrderPage: {
      queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
    },
    getUserOffering: {
      queryConfigType: QueryConfigTypes.MODERATE_DATA
    },
    getProductInfo: {
      queryConfigType: QueryConfigTypes.MODERATE_DATA
    }
  }
});
export const PremiumStoreSaleApiConfig = createMetroApiConfig(PremiumStoreSalesService, {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.FIXED_DATA
  }
});
const PremiumDataViewRetrieverConfigs = {
  users: createProtoV1ApiConfig(PremiumDataViewRetrieverServer('/_api/premium-assets/', {
    ignoredProtoHttpUrlPart: '/api'
  }).UserPremiumAssetsServiceV1()()),
  sites: createProtoV1ApiConfig(PremiumDataViewRetrieverServer('/_api/premium-assets/').SitePremiumAssetsServiceV1()())
};
export const PremiumDataViewRetrieverConfig = combineApiConfigs(PremiumDataViewRetrieverConfigs.sites, PremiumDataViewRetrieverConfigs.users);
const PremiumStoreApiConfigs = {
  dynamic: PremiumStoreDynamicOfferingApiConfig,
  currency: PremiumCurrencyApiConfig,
  sale: PremiumStoreSaleApiConfig
};
export const PremiumStoreApiConfig = combineApiConfigs(PremiumStoreApiConfigs.dynamic, PremiumStoreApiConfigs.currency, PremiumStoreApiConfigs.sale);
export const MetaSiteInstanceApiConfig = createProtoV1ApiConfig(WixMetaSiteManagerWebapp('/_api/msm').MetaSiteReadApi()(), {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  methodsOptions: {
    getEditorClientSpecMap: {
      reactQueryOptions: {
        staleTime: 1000 * 60 * 60 * 4,
        refetchOnWindowFocus: true
      }
    }
  }
});
//# sourceMappingURL=configurations.js.map